import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee"

const Instructions = () => {
    return (
        <div>
            <div className="container">
                <Search />
                <h4 class="pb-4 pt-4 mb-4  ">
                    Дастурҳо
                </h4>
                <div>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="https://www.maorif.tj/storage/Dokument's/Dasturho/ad5434c133a7dba83dc1a740fd36ff5e.pdf">"МО БАР ЗИДДИ КОРРУПСИЯ ДАР СОҲАИ МАОРИФ"</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="https://www.maorif.tj/storage/Dokument's/Dasturho/f8d39529072817c0b3324ecf13462457.pdf">ДАСТУРИ МУҚОВИМАТ БО КОРРУПСИЯ</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="http://maorif.tj/storage/Dokument's/Dasturho/0e53f222c9ee3ec64b30b2c8bfeb8d66.pdf">ДАСТУРАМАЛИ НАМУНАВИИ НИГОҲДОРИИ ҲУҶҶАТҲО ДАР БОЙГОНИИ МУАССИСАҲОИ ТАЪЛИМИИ ҶУМҲУРИИ ТОҶИКИСТОН</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="http://maorif.tj/storage/Dokument's/Dasturho/512bb7a13d66561296240b8fc545d9a0.pdf">ДАСТУРАМАЛИ ЛИБОСҲОИ ТАВСИЯВӢ БАРОИ ХОНАНДАГОНУ ДОНИШҶӮЁН ВА ОМӮЗГОРОНИ МУАССИСАҲОИ ТАЪЛИМИИ ҶУМҲУРИИ ТОҶИКИСТОН</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="http://maorif.tj/storage/Dokument's/9ccb2179a8b01fe6f2659065d797d050.pdf">ДАСТУРИ ТАВСИЯВИ ОИДИ АЗ АВВАЛИ МОҲИ МАРТ ПУШИДАНИ САРУ ЛИБОСИ ХОСИ МИЛЛӢ</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="http://maorif.tj/storage/Dokument's/cb311d7b76e10135dc5c1f5c1e64e0e6.pdf">ДАСТУР ДОИР БА ТАРЗИ ТАЪЛИФИ ЭССЕ</a></p>
                    <div className="p-3  " style={{ "display": "flex", "justify-content": "center" }} >
                        <img src="https://maorif.tj/storage/posts/April2018/Qa2mcOGeIyBvy6XqbTbR.jpg" height={50}></img>
                    </div>
                    <p className="text-center"> <a href="http://maorif.tj/storage/Dokument's/Dasturho/6b7a4e920aab452ac6e3fbc70d7cb96c.pdf">ДАСТУРАМАЛИ ВАЗИФАВИИ КОРМАНДОНИ МУАССИСАҲОИ ТАҲСИЛОТИ ИБТИДОИИ КАСБИИ ҶУМҲУРИИ ТОҶИКИСТОН</a></p>


                </div>

            </div>
            <Marquee />
        </div >
    )
}
export default Instructions;